import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ErrorBoundary from 'components/common/ErrorBoundary';

/**
 * Formatea fecha en formato corto
 */
const formatDate = (fecha) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('es-MX', options).toUpperCase();
};

/**
 * Componente para mostrar renovaciones de licencias asignadas
 */
const RenovacionesAsignadas = ({ objLicRenov, product }) => {
    const esProductoRenovacion =
        product.vCodigoBarras === "LIC-NUB-RENOV" ||
        product.vCodigoBarras === "LIC-NUB-MEN" ||
        product.vCodigoBarras === "LIC-SERV-MEN";

    return (
        <ErrorBoundary>
            {objLicRenov.map((licRen, index) => {
                const keyRenov = licRen.idLicencia > 0
                    ? `renov-${product.idOrdenDetalle}-${licRen.idLicencia}`
                    : `renov-empty-${product.idOrdenDetalle}-${index}`;

                // Si tiene renovación asignada
                if (licRen.idLicencia > 0) {
                    return (
                        <Col
                            key={keyRenov}
                            xs={12}
                            md={6}
                            className="pr-1 mb-2"
                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                        >
                            <img className="mr-2" src="/img/activo.png" alt="" />
                            <Link
                                to={`/licencias/detalle/${licRen.idLicencia}`}
                                target="_blank"
                                className="stretched-link text-info position-relative"
                            >
                                LIC #{licRen.idLicencia}
                            </Link>
                            &nbsp;x {licRen.iNumeroDias}D&nbsp;|&nbsp;
                            <span className="fs--2">{formatDate(licRen.dCreatedDate)}</span>
                        </Col>
                    );
                }

                // Si es un producto de renovación sin asignar
                if (esProductoRenovacion) {
                    return (
                        <Col
                            key={keyRenov}
                            xs={12}
                            md={12}
                            className="pr-1 mb-2"
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="ms-2 badge badge-soft-warning">NO HA SIDO RENOVADA</span>
                        </Col>
                    );
                }

                return null;
            })}
        </ErrorBoundary>
    );
};

RenovacionesAsignadas.propTypes = {
    objLicRenov: PropTypes.array.isRequired,
    product: PropTypes.object.isRequired
};

export default RenovacionesAsignadas;
